import { useShowContext } from 'framework/show';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';
import { useOpportunityId } from 'domain/shared/opportunity';
import { UPDATE_PRESALE_OUTPUT } from 'domain/sales/opportunity/opportunityService';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { Collapsible } from 'framework/ui/field';
import PresaleOutputFields from 'domain/sales/opportunity/presale/output/PresaleOutputTimelineRecordLayout/PresaleOutputFields';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';

const PresaleOutputTimelineRecordLayout = ({ onEdit, isPinned, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { data } = useShowContext();
  const timelineId = data.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const buttons = [<EditTimelineRecordButton onEdit={onEdit} permissionToCheck={UPDATE_PRESALE_OUTPUT} />];

  return (
    <BaseTimelineRecordLayout
      fields={
        <Collapsible>
          <PresaleOutputFields />
        </Collapsible>
      }
      entity={data}
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      actions={[
        <PinTimelineButton
          pinStatus={isPinned}
          pinMethod={async () => {
            const response = await pinTimelineAction!(opportunityId, timelineId, !isPinned);
            updateInList!(response?.id, response);
          }}
        />,
      ]}
      timelineFooter={() => null}
      {...props}
    />
  );
};

export default PresaleOutputTimelineRecordLayout;
